var map = {
	"./fonts/Digital_numbers/DigitalNumbers-Regular.ttf": 2777,
	"./fonts/Exo_2/Exo2-Italic-VariableFont_wght.ttf": 6177,
	"./fonts/Exo_2/Exo2-VariableFont_wght.ttf": 8612,
	"./fonts/Exo_2/static/Exo2-Black.ttf": 7586,
	"./fonts/Exo_2/static/Exo2-BlackItalic.ttf": 8503,
	"./fonts/Exo_2/static/Exo2-Bold.ttf": 7557,
	"./fonts/Exo_2/static/Exo2-BoldItalic.ttf": 5750,
	"./fonts/Exo_2/static/Exo2-ExtraBold.ttf": 6106,
	"./fonts/Exo_2/static/Exo2-ExtraBoldItalic.ttf": 1325,
	"./fonts/Exo_2/static/Exo2-ExtraLight.ttf": 9142,
	"./fonts/Exo_2/static/Exo2-ExtraLightItalic.ttf": 909,
	"./fonts/Exo_2/static/Exo2-Italic.ttf": 5428,
	"./fonts/Exo_2/static/Exo2-Light.ttf": 1483,
	"./fonts/Exo_2/static/Exo2-LightItalic.ttf": 3272,
	"./fonts/Exo_2/static/Exo2-Medium.ttf": 9553,
	"./fonts/Exo_2/static/Exo2-MediumItalic.ttf": 5049,
	"./fonts/Exo_2/static/Exo2-Regular.ttf": 1518,
	"./fonts/Exo_2/static/Exo2-SemiBold.ttf": 2074,
	"./fonts/Exo_2/static/Exo2-SemiBoldItalic.ttf": 1175,
	"./fonts/Exo_2/static/Exo2-Thin.ttf": 7313,
	"./fonts/Exo_2/static/Exo2-ThinItalic.ttf": 361,
	"./fonts/Inter/Inter-VariableFont_slnt,wght.ttf": 6246,
	"./fonts/Inter/static/Inter-Black.ttf": 5972,
	"./fonts/Inter/static/Inter-Bold.ttf": 690,
	"./fonts/Inter/static/Inter-ExtraBold.ttf": 1231,
	"./fonts/Inter/static/Inter-ExtraLight.ttf": 8412,
	"./fonts/Inter/static/Inter-Light.ttf": 9929,
	"./fonts/Inter/static/Inter-Medium.ttf": 7517,
	"./fonts/Inter/static/Inter-Regular.ttf": 8525,
	"./fonts/Inter/static/Inter-SemiBold.ttf": 7387,
	"./fonts/Inter/static/Inter-Thin.ttf": 6562,
	"./fonts/Square_peg/SquarePeg-Regular.ttf": 6394,
	"./fonts/droidKufi/DroidKufi-Regular.woff2": 9055,
	"./icons/010-logout.svg": 8539,
	"./icons/017-copy.svg": 3094,
	"./icons/021-refresh-gris.svg": 3036,
	"./icons/021-refresh.svg": 4073,
	"./icons/044-45minutes.svg": 6573,
	"./icons/044-uparrow.svg": 2514,
	"./icons/053-edit.svg": 87,
	"./icons/074-bin.svg": 4865,
	"./icons/add-client.svg": 5598,
	"./icons/affichage-icon.svg": 7137,
	"./icons/arabic.svg": 5699,
	"./icons/archive-clock-icon.svg": 9902,
	"./icons/archive-office-icon.svg": 203,
	"./icons/arrow-button-icon.svg": 1009,
	"./icons/assistance-icon.svg": 853,
	"./icons/billing-machine-icon.svg": 2307,
	"./icons/booking-add-white.svg": 7288,
	"./icons/booking-add.svg": 3693,
	"./icons/calendar-grey-icon.svg": 3106,
	"./icons/calendar-icon.svg": 1710,
	"./icons/call-icon.svg": 3213,
	"./icons/clear-button-icon.svg": 5396,
	"./icons/controlls-icon.svg": 6000,
	"./icons/delete-button-icon.svg": 5779,
	"./icons/delete-red-icon.svg": 998,
	"./icons/dollar-grey.svg": 2176,
	"./icons/dollar.svg": 6025,
	"./icons/down-arrow.svg": 1481,
	"./icons/eject-button-icon.svg": 9748,
	"./icons/email-icon.svg": 8692,
	"./icons/english.svg": 837,
	"./icons/error-icon.svg": 7684,
	"./icons/file-attente-icon.svg": 2840,
	"./icons/folder-icon.svg": 8577,
	"./icons/french.svg": 6827,
	"./icons/historique-icon.svg": 31,
	"./icons/hourglass-button-icon.svg": 2765,
	"./icons/info-grey.svg": 1578,
	"./icons/info-icon.svg": 3309,
	"./icons/info-white.svg": 920,
	"./icons/language-icon.svg": 5385,
	"./icons/left-arrow-white.svg": 7242,
	"./icons/left-arrow.svg": 7352,
	"./icons/login-MS.svg": 7770,
	"./icons/login-icon.svg": 5375,
	"./icons/logout-icon.svg": 6499,
	"./icons/menu-button-icon-white.svg": 4102,
	"./icons/menu-button-icon.svg": 5642,
	"./icons/minutes-icon.svg": 2152,
	"./icons/next-button-icon-rtl.svg": 4247,
	"./icons/next-button-icon.svg": 5456,
	"./icons/paginator-left-arrow.svg": 112,
	"./icons/paginator-right-arrow.svg": 6796,
	"./icons/password-icon.svg": 9044,
	"./icons/plus sign.svg": 9133,
	"./icons/radio-button-grey-icon.svg": 9702,
	"./icons/radio-button-white-icon.svg": 6282,
	"./icons/remove-button-icon.svg": 2837,
	"./icons/request-callback-icon.svg": 3212,
	"./icons/right-arrow-white.svg": 2340,
	"./icons/settings-icon.svg": 3350,
	"./icons/star-grey.svg": 2299,
	"./icons/star-yellow.svg": 6135,
	"./icons/stop-icon.svg": 357,
	"./icons/stopwatch-icon-red.svg": 2832,
	"./icons/stopwatch-icon.svg": 2573,
	"./icons/tick-mark-icon.svg": 4256,
	"./icons/ticket-icon-white.svg": 4464,
	"./icons/ticket-icon.svg": 9271,
	"./icons/total-serv.svg": 8013,
	"./icons/volume-up-button-icon.svg": 1902,
	"./icons/waiting-queue-icon.svg": 8147,
	"./icons/web-browser-icon.svg": 4425,
	"./images/Logo_Bleu.png": 5988,
	"./images/arrow.png": 4931,
	"./images/avatar.png": 8987,
	"./images/no-ticket-data.png": 5581,
	"./images/p1.jpg": 5762,
	"./images/statistics-image.png": 1459,
	"./sounds/slow-spring-board.mp3": 3981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;